import src from "IMAGE";
export default { src, width: 256, height: 256, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
